import { Station } from '@app/core/types/stations';
import { getAuditListingDefaultDate } from '@app/modules/audit/modules/station-audit/helpers/default-listing-date-range';
import { DateStr, PntStationStatusReportDtoV2 } from '@mi-front/core';
import { apiClient } from '../../../../../../../../api';
import { ReportView } from '../../../../../../../../core/reports/components/ReportView';
import { ReportType } from '../../../../../../../../core/reports/types';
import { ScheduleStatusMentionsForm } from './ScheduleStatusMentionsForm';
import { ScheduleStatusMentionsResult } from './ScheduleStatusMentionsResult';

interface Props {
  readonly station: Station;
}

export type ScheduleStatusMentionsReport = ReportType<
  { date: DateStr; customId: string },
  PntStationStatusReportDtoV2
>;

/** Mentions schedule-status report for a station (single date, optional mention ID). */
export function ScheduleStatusMentionsView(p: Props) {
  return (
    <ReportView<ScheduleStatusMentionsReport>
      defaultValues={{
        date: getAuditListingDefaultDate(),
        customId: '',
      }}
      runOnLoad
      download={false}
      getResultCount={(result) => result.items.length}
      queryParamsTransform={{
        customId: {
          parse: (input) => input,
          serialize: (input) => input.replace(/\s/g, ''),
        },
      }}
      reportFn={async (values) => {
        return apiClient.audit.stationReportsScheduleStatusPnt({
          stationId: p.station.id,
          date: values.date,
          customId: values.customId || undefined,
        });
      }}
      Form={ScheduleStatusMentionsForm}
      Result={ScheduleStatusMentionsResult}
    />
  );
}
